import { GridApi, GridState } from '@ag-grid-community/core';
import { createAppStore } from '@store/createAppStore';
import { QueueTargetT } from '@views/billingQueues/components/types';

import { BillingQueueStore } from './consts';
import { BillingQueueStoreType, BillingQueueTabKey } from './types';

type BillingQueueExtendedStore = BillingQueueStoreType & {
  activeTab: number;
  tabCaches: Record<BillingQueueTabKey, GridState | undefined>;
};

const extendedBillingQueueStore: BillingQueueExtendedStore = {
  ...BillingQueueStore,
  activeTab: 0,
  tabCaches: {
    UploadQueue: undefined,
    Approved: undefined,
    ReviewDocuments: undefined,
    UnknownDocuments: undefined,
    Responded: undefined,
    PendingApprovals: undefined,
    Disputed: undefined,
    DocumentHistory: undefined,
  },
};

const [billingQueueStore, setBillingQueueStore] =
  createAppStore<BillingQueueExtendedStore>(
    extendedBillingQueueStore,
    'billingQueueStore',
  );

const [gridRefStore, setGridRefStore] = createAppStore<
  Record<QueueTargetT, GridApi | undefined>
>(
  {
    upload: undefined,
    reviewDocument: undefined,
    unknownDocument: undefined,
    responded: undefined,
    pending: undefined,
    history: undefined,
    approved: undefined,
    disputed: undefined,
  },
  'gridRefStore',
);

// @ts-expect-error intentional exposure
window.bqStore = {
  billingQueueStore,
  gridRefStore,
  setBillingQueueStore,
  setGridRefStore,
};

export {
  billingQueueStore,
  gridRefStore,
  setBillingQueueStore,
  setGridRefStore,
};
